import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

export default function Dashboard() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) navigate("/");
    else if (!user.role) navigate("/onboarding");
    else if (user.role === "student") navigate("/student/dashboard");
    else navigate("/teacher/dashboard");
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F7F4]">
      <div className="w-10 h-10 border-4 border-[#163A24] border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
